import { useEffect, useState } from "react";
import QuizStudentApp from "./QuizStudentApp";
import SecureQuizStudent from "./SecureQuizStudent";

export default function QcmEntryRouter() {
  const code = window.location.pathname.match(/^\/qcm\/([0-9]{6})/)?.[1] ?? "";
  const [secure, setSecure] = useState<boolean | null>(null);

  useEffect(() => {
    let active = true;
    fetch(`/api/secure-qcm/probe/${code}`, { credentials: "include", cache: "no-store" })
      .then((response) => response.ok ? response.json() : { secure: false })
      .then((body) => { if (active) setSecure(Boolean(body.secure)); })
      .catch(() => { if (active) setSecure(false); });
    return () => { active = false; };
  }, [code]);

  if (secure === null) return <main className="secure-qcm-router-loading"><div className="loading-ring" /></main>;
  return secure ? <SecureQuizStudent code={code} /> : <QuizStudentApp />;
}
